export const ExclusivePromoLabel = () => (
  <div>
    <span>
      Promo solo en <b>insuma</b> 🔥
    </span>
  </div>
);
